/**
 * Aggregate MUI component overrides – single import for theme.
 */
import { MuiButtonOverrides } from "./button";
import { MuiTextFieldOverrides } from "./textField";
import { MuiInputBaseOverrides } from "./inputBase";

export const componentOverrides = {
  MuiButton: MuiButtonOverrides,
  MuiTextField: MuiTextFieldOverrides,
  MuiInputBase: MuiInputBaseOverrides,
};

export { MuiButtonOverrides } from "./button";
export { MuiTextFieldOverrides } from "./textField";
export { MuiInputBaseOverrides } from "./inputBase";
